(() => {
  function debounce(fn, delay3) {
    let timer = null;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay3);
    };
  }
  window._debounce = debounce;

  function syncHeaderCartCount(count) {
    document
      .querySelectorAll("[data-cart-count], .js-cart-count, .cart-count, .jsccount")
      .forEach((el) => {
        el.textContent = count;
        el.classList.toggle("hidden", count === 0);
      });
  }

  function attachCartSections(payload) {
    payload = payload || {};
    if (window.tsCart && typeof window.tsCart.attachSections === "function") {
      return window.tsCart.attachSections(payload);
    }
    const ids = [];
    document.querySelectorAll("[data-ts-cart-section]").forEach((el) => {
      const id =
        el.getAttribute("data-section-id") || (el.id || "").replace("shopify-section-", "");
      if (id && !ids.includes(id)) ids.push(id);
    });
    if (ids.length) {
      payload.sections = ids;
      payload.sections_url = window.location.pathname + window.location.search || "/";
    }
    return payload;
  }

  function hasCartDrawer() {
    return Boolean(document.querySelector("[data-ts-cart-drawer]"));
  }

  let judgeme_product_reviewsTimSum = 0
  let judgeme_product_reviewsTim = setInterval(() => {
    let judgeme_product_reviews = document.querySelector("#judgeme_product_reviews");
    judgeme_product_reviews?.parentElement.classList.add("judgeme_product_reviews-container");
    if (judgeme_product_reviews || judgeme_product_reviewsTimSum > 100) {
      return clearInterval(judgeme_product_reviewsTim)
    }
  }, 1000);

  /**
 * 等待用户第一次交互后执行回调函数
 * @param {Function} callback - 用户交互后要执行的回调函数
 * @param {Object} options - 配置选项
 * @param {Array<string>} options.events - 要监听的交互事件类型，默认为 ['click', 'scroll', 'keydown', 'touchstart', 'mousemove']
 * @param {boolean} options.once - 是否只执行一次，默认为 true
 * @returns {Function} 返回清理函数，可以手动移除监听器
  */
  function waitForUserInteraction(callback, options = {}) {
    const {
      events = ['click', 'scroll', 'keydown', 'touchstart', 'mousemove'],
      once = true
    } = options;

    let hasInteracted = false;
    const eventHandlers = new Map();

    const handleInteraction = () => {
      if (hasInteracted && once) return;
      hasInteracted = true;

      // 移除所有事件监听器
      events.forEach(eventType => {
        const handler = eventHandlers.get(eventType);
        if (handler) {
          document.removeEventListener(eventType, handler, true);
          eventHandlers.delete(eventType);
        }
      });

      // 执行回调
      if (typeof callback === 'function') {
        callback();
      }
    };

    // 添加事件监听器
    events.forEach(eventType => {
      document.addEventListener(eventType, handleInteraction, true);
      eventHandlers.set(eventType, handleInteraction);
    });

    // 返回清理函数
    return () => {
      events.forEach(eventType => {
        const handler = eventHandlers.get(eventType);
        if (handler) {
          document.removeEventListener(eventType, handler, true);
        }
      });
      eventHandlers.clear();
    };
  }

  // 公共类可继承open属性
  const GlobalHTMLElement = class extends HTMLElement {
    static get observedAttributes() {
      return ["open"];
    }
    constructor() {
      super();
    }
    get open() {
      return this.hasAttribute("open");
    }
    set open(value) {
      if (value) {
        (async () => {
          this.setAttribute("open", "");
        })();
      } else {
        this.removeAttribute("open");
      }
    }

    listenerKeydown() {
      document.addEventListener("keydown", (e) => {
        if (this.open == true && e.code == "Escape") {
          this.open = false;
        }
      });
    }
  };

  // swiper-component 自定义轮播组件
  customElements.define(
    "swiper-component",
    class SwiperComponent extends GlobalHTMLElement {
      custom_pagination = {
        total: 0,
        current: 0,
      };
      swiper_options = {
        slidesPerView: 1,
        spaceBetween: 40,
        loop: false,
        autoplay: false,
        watchOverflow: true,
      };
      constructor() {
        super();
        // 执行一次
        this.lock = true;
        // 自定义切换按钮
        this.custom_prev_btn = this.querySelector(".swiper-pagination-prev");
        this.custom_next_btn = this.querySelector(".swiper-pagination-next");
        this.custom_swiper_tabs = this.querySelectorAll(".swiper-tab-item");
      }
      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
        }
      }
      connectedCallback() {}
      attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
          case "open":
            if (this.hasAttribute("open") && this.lock) {
              this.lock = false;
              this.startSwiper();
            }
        }
      }
      startSwiper() {
          this.initPagination();
          this.initSwiper();
        // 自定义切换按钮
          this.initCuPaginationButton();
      }

      initSwiper() {
        this.waitForInteraction = this.dataset.waitForInteraction !== undefined && this.dataset.waitForInteraction !== 'false';
        this.autoplay = this.dataset.autoplay !== undefined ? JSON.parse(this.dataset.autoplay) : false;
        // 不在初始化时设置autoplay
        Object.keys(this.dataset).forEach((key) => {
          if (key === 'waitForInteraction') {
            return; // 跳过这个属性
          }
          if (key === 'autoplay') {
            return;
          }
          if (key === 'role') {
            return;
          }
          this.swiper_options[key] = JSON.parse(this.dataset[key]);
        });
        // console.log('swiper_options', this.swiper_options);
        this.swiper = new Swiper(this.querySelector(".swiper"), {
          ...this.swiper_options,
        });
        document.dispatchEvent(
          new CustomEvent('swiper-component:ready', {
            bubbles: true,
            detail: {
              swiper: this.swiper,
              swiperComponent: this
            }
          })
        )
        this.swiper["custom_pagination"] = this.custom_pagination;
        this.swiper.on("slideChange", (item) => {
          this.custom_pagination["current"] = item.realIndex + 1;
          this.swiper["custom_pagination"] = this.custom_pagination;
          this.updateCuPaginationButton();
          this.selectTabsItem(item.realIndex);
        });
        if (this.dataset.progress) {
          this.querySelector('.swiper').classList.add("swiper-autoplay")
          this.swiper.on("autoplayTimeLeft", (s, time, progress) => {
            this.style.setProperty(`--pagination-progress`, ((1 - progress) * 100).toFixed(0) + '%')
            // 你可以将 progress 用于进度条或圆环展示
          })
        }
        if (this.waitForInteraction && this.autoplay) {
          var interactionCleanup = waitForUserInteraction(() => {
            this.swiper.params.autoplay.disableOnInteraction = this.autoplay.disableOnInteraction;
            this.swiper.params.autoplay.delay = this.autoplay.delay;
            this.swiper.autoplay.start();
          });
        } else if (this.autoplay) {
          this.swiper.params.autoplay.disableOnInteraction = this.autoplay.disableOnInteraction;
          this.swiper.params.autoplay.delay = this.autoplay.delay;
          this.swiper.autoplay.start();
        }
      }
      slideTo(index) {
        this.swiper.slideTo(index);
      }

      initPagination() {
        if (
          this.querySelector(".swiper-button-next") &&
          this.querySelector(".swiper-button-prev")
        ) {
          this.swiper_options.navigation = {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          };
        }
        if (this.querySelector(".swiper-pagination.swiper-pagination-progressbar")) {
          this.swiper_options.pagination = {
            el: this.querySelector(".swiper-pagination.swiper-pagination-progressbar"),
            type: "progressbar",
          };
        } else if (
          this.querySelector(
            ".swiper-pagination.swiper-pagination-dynamicBullets"
          )
        ) {
          this.swiper_options.pagination = {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
            dynamicBullets: true,
          };
        } else if (this.querySelector(".swiper-pagination-custom")) {
          const _this = this;
          this.swiper_options.pagination = {
            el: this.querySelector(".swiper-pagination-custom"),
            clickable: true,
            type: "custom",
            renderCustom: function (swiper, current, total) {
              _this.custom_pagination = {
                current,
                total,
              };
              return null;
            },
          };
        } else if (this.querySelector(".swiper-pagination")) {
          this.swiper_options.pagination = {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          };
        }
      }
      initCuPaginationButton() {
        if (this.custom_next_btn && this.custom_prev_btn) {
          this.updateCuPaginationButton();
          this.custom_prev_btn.onclick = () => {
            this.swiper.slidePrev();
            this.updateCuPaginationButton();
          };
          this.custom_next_btn.onclick = () => {
            this.swiper.slideNext();
            this.updateCuPaginationButton();
          };
        }
        if (this.custom_swiper_tabs.length) {
          this.selectTabsItem(0);
          this.custom_swiper_tabs.forEach((item, index) => {
            item.onclick = () => {
              this.selectTabsItem(index);
            };
          });
        }
      }

      selectTabsItem(index) {
        if (this.custom_swiper_tabs.length) {
          $(this.custom_swiper_tabs)
            .not(this.custom_swiper_tabs[index])
            .removeClass("active");
          this.custom_swiper_tabs[index].classList.add("active");
          this.swiper.slideTo(index);
        }
      }
      updateCuPaginationButton() {
        if (!this.custom_next_btn && !this.custom_prev_btn) return;
        this.custom_prev_btn.disabled = this.swiper.activeIndex == 0;
        this.custom_next_btn.disabled = this.swiper.isEnd;
      }
    }
  );

  customElements.define(
    "product-media-hover",
    class ProductMediaHover extends HTMLElement {
      constructor() {
        super();
        this._swiper = null;
        this._initialized = false;
        this._hasHover = window.matchMedia("(hover: hover)").matches;
        this._onSwiperReady = this._onSwiperReady.bind(this);
        this._onMouseEnter = this._onMouseEnter.bind(this);
        this._onMouseLeave = this._onMouseLeave.bind(this);
        this._onNavClick = this._onNavClick.bind(this);
        this._onSlideChange = this._onSlideChange.bind(this);
      }

      connectedCallback() {
        this.addEventListener("click", this._onNavClick);

        if (!this._hasHover) {
          return;
        }

        this.addEventListener("mouseenter", this._onMouseEnter);
        this.addEventListener("mouseleave", this._onMouseLeave);
      }

      disconnectedCallback() {
        this.removeEventListener("click", this._onNavClick);
        this.removeEventListener("mouseenter", this._onMouseEnter);
        this.removeEventListener("mouseleave", this._onMouseLeave);
        document.removeEventListener("swiper-component:ready", this._onSwiperReady);
        if (this._boundSwiper) {
          this._boundSwiper.off("slideChange", this._onSlideChange);
        }
      }

      _onNavClick(event) {
        if (event.target.closest(".swiper-button-prev, .swiper-button-next")) {
          event.stopPropagation();
        }
      }

      _onSwiperReady(event) {
        const swiperComponent = event.detail && event.detail.swiperComponent;
        if (!swiperComponent || !this.contains(swiperComponent)) {
          return;
        }
        this._attachSwiper(event.detail.swiper);
      }

      _attachSwiper(swiper) {
        if (this._boundSwiper) {
          this._boundSwiper.off("slideChange", this._onSlideChange);
        }
        this._swiper = swiper;
        this._boundSwiper = swiper;
        this._syncPagination(swiper);
        swiper.on("slideChange", this._onSlideChange);
      }

      _onSlideChange() {
        if (this._swiper) {
          this._syncPagination(this._swiper);
        }
      }

      _syncPagination(swiper) {
        const count = swiper.snapGrid ? swiper.snapGrid.length : swiper.slides.length;
        this.style.setProperty("--pmh-slide-count", count);
        this.style.setProperty("--pmh-pagination-index", swiper.realIndex);
      }

      ensureInit() {
        const swiperComponent = this.querySelector("swiper-component");
        if (!swiperComponent || this._initialized) {
          return;
        }

        this._initialized = true;
        document.addEventListener("swiper-component:ready", this._onSwiperReady);

        if (!swiperComponent.hasAttribute("open")) {
          swiperComponent.setAttribute("open", "");
        } else if (swiperComponent.swiper) {
          this._attachSwiper(swiperComponent.swiper);
        }
      }

      resetToFirst() {
        const swiper = this._swiper;
        if (!swiper) {
          return;
        }

        if (swiper.params.loop) {
          swiper.slideToLoop(0, 0);
        } else {
          swiper.slideTo(0, 0);
        }
        this._syncPagination(swiper);
      }

      _setScenesAria(active) {
        const scenes = this.querySelector(".product-media-hover__scenes");
        if (scenes) {
          scenes.setAttribute("aria-hidden", active ? "false" : "true");
        }
      }

      _onMouseEnter() {
        this.ensureInit();
        this.classList.add("is-active");
        this._setScenesAria(true);
      }

      _onMouseLeave() {
        this.classList.remove("is-active");
        this._setScenesAria(false);
        this.resetToFirst();
      }
    }
  );

  /**
   * 唤醒弹窗按钮有两种唤醒方式
   * 1. global-modal-button子元素包含template
   * 2. global-modal-button data-id 不为空
   * 
   * */

  customElements.define("global-modal-button", class GlobalModalButton extends HTMLElement {
    constructor() {
      super();
      this.childHtml = this.querySelector('template')?.innerHTML
    }
    connectedCallback() {
      if (this.childHtml || this.dataset.modalId) {
        this.addEventListener("click", this.openGlobalModalHandle)
      } else {
        return new Error("data-modal-id或子元素template不能为空");
      }

    }
    openGlobalModalHandle() {
      const _this = this
      console.log("this.childHtml", `${this.querySelector('template')?.innerHTML}`)
      if (_this.childHtml) {
        document.dispatchEvent(new CustomEvent('open-global-modal', {
          bubbles: true,
          detail: {
            childHtml: _this.childHtml,
            contentClass: _this.dataset.contentClass
          }
        }))
      } else {
        const modalContainer = document.getElementById(this.dataset.modalId);
        modalContainer.toggleAttribute("open");
        modalContainer.hasAttribute('open') ? document.body.classList.add("overflow-hidden") : document.body.classList.remove("overflow-hidden")
        if (this.dataset.index) {
          modalContainer?.slideTo(this.dataset.index)
        }

      }

    }
    disconnectedCallback() {
      this.removeEventListener("click", this.openGlobalModalHandle)
    }
  }
  );

  customElements.define(
    "global-modal",
    class GlobalModal extends GlobalHTMLElement {
      constructor() {
        super();
        this.childHtml = null
        this.modalContent = this.querySelector(".global-modal-content")
        this.listenerKeydown();
      }
      listenerKeydown() {
        document.addEventListener("keydown", (e) => {
          if (this.open && e.code === "Escape") {
            this.removeContent();
          }
        });
      }
      connectedCallback() {
        this.addEventListener("click", (e) => {
          if (
            this.open &&
            (e.target === this ||
              e.target === this.querySelector('.global-modal-close') ||
              e.target.closest('.global-modal-info-close'))
          ) {
            this.removeContent()
          }
        });
        document.addEventListener("open-global-modal", (e) => {
          this.modalContent.className = 'global-modal-content';
          this.childHtml = e.detail.childHtml;
          this.modalContent.innerHTML = e.detail.childHtml;
          if (e.detail.contentClass) {
            this.modalContent.classList.add(e.detail.contentClass);
          }
          this.open = true;
          document.body.classList.add("tw-overflow-hidden")
        })
      }
      removeContent() {
        this.open = false;
        this.modalContent.className = 'global-modal-content';
        this.modalContent.innerHTML = '';
        this.childHtml = null;
        document.body.classList.remove("tw-overflow-hidden")
      }
    }
  );

  // 加购按钮
  customElements.define(
    "add-cart-button",
    class AddCartButton extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.addEventListener("click", () => {
          if (this.hasAttribute("disabled")) return;
          this.addToCart(this.dataset.variantId);
        });
      }
      addToCart(variantId) {
        if (this.hasAttribute("disabled")) return;
        const _this = this;
        let formData = {
          items: [
            {
              id: Number(variantId),
              quantity: 1,
            },
          ],
        };
        attachCartSections(formData);
        this.classList.add("button-loading");
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((res) => {
            if (res.status && res.status !== 200) {
              console.error("Error adding to cart:", res.description || res.message);
              return;
            }
            document.dispatchEvent(
              new CustomEvent("ts:cart:updated", {
                bubbles: true,
                detail: {
                  source: "add-cart-button",
                  sections: res.sections || {},
                  open: hasCartDrawer(),
                },
              })
            );
            if (typeof res.item_count === "number") {
              syncHeaderCartCount(res.item_count);
            } else if (!document.querySelector(".section-cart-wrap")) {
              fetch(window.Shopify.routes.root + "cart.js", { credentials: "same-origin" })
                .then((cartRes) => cartRes.json())
                .then((cart) => {
                  if (typeof cart.item_count === "number") syncHeaderCartCount(cart.item_count);
                })
                .catch(() => {});
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            _this.classList.remove("button-loading");
          });
      }
    }
  );

  customElements.define(
    "image-lazy-load",
    class ImageLazyLoad extends HTMLElement {
      constructor() {
        super();
        this.image = this.querySelector(".img--lazyload");
        this.initImageLazyLoad();
      }

      initImageLazyLoad() {
        if ("IntersectionObserver" in window) {
          const lazyImageObserver = new IntersectionObserver(function (
            entries,
            observer
          ) {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                let lazyImage = entry.target;
                lazyImage.src = lazyImage.dataset.src;
                lazyImage.classList.add("lazyloaded");
                observer.unobserve(entry.target);
              }
            });
          });
          lazyImageObserver.observe(this.image);
        } else {
          let active = false;
          const _this = this;
          let lazyLoad = () => {
            if (active === false) {
              active = true;
              setTimeout(() => {
                const lazyImage = _this.image;
                if (
                  lazyImage.getBoundingClientRect().top <= window.innerHeight &&
                  lazyImage.getBoundingClientRect().bottom >= 0 &&
                  getComputedStyle(lazyImage).display !== "none"
                ) {
                  lazyImage.src = lazyImage.dataset.src;
                  // lazyImage.classList.remove("lazy");
                  lazyImage.classList.add("lazyloaded");
                }
                active = false;
              }, 200);
            }
          };
          document.addEventListener("scroll", lazyLoad);
          window.addEventListener("resize", lazyLoad);
          window.addEventListener("orientationchange", lazyLoad);
        }
      }
    }
  );

  class NavigationSticky extends HTMLElement {
    constructor() {
      super();
      this.stickyContainer = document.getElementById(
        `${this.dataset.stickyId}`
      );
      if (!this.stickyContainer) return;
      this.headerHeight =
        document
          .querySelector(".shopify-section--header")
          ?.getBoundingClientRect().height ?? 0;
      this.announcementBarHeight =
        document
          .querySelector(".shopify-section--announcement-bar")
          ?.getBoundingClientRect().height ?? 0;
      this.listenerScroll();
      this.listenerItemHandle()
    }

    listenerItemHandle() {
      const links = Array.from(this.querySelectorAll(".product-navigation-link"))
      links.forEach((item) => {
        item.onclick = () => {
          item.classList.add("active")
          links.filter(t => t != item).forEach(t => t.classList.remove('active'))
        }
      })
    }
    listenerScroll() {
      window.addEventListener("scroll", () => {
        if (this.getScrollTop() > this.getBoundingClientRect().top) {
          this.updateElementTopValue();
        }
      });
    }
    updateElementTopValue() {
      if (this.isScrollDown()) {
        this.stickyContainer.style.top = `-${this.headerHeight}px`;
      } else {
        this.stickyContainer.style.top = `${this.headerHeight + this.announcementBarHeight
          }px`;
      }
    }
    isScrollDown() {
      const scrollY = this.getScrollTop();
      let delta = scrollY - this.curScrollY;
      this.curScrollY = scrollY;
      return delta > 0;
    }
    getScrollTop() {
      return (
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.scrollY ||
        0
      );
    }
  }
  customElements.define("navigation-sticky", NavigationSticky);

  customElements.define(
    "global-tabs",
    class SectionPartnersContent extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.tabs = this.querySelectorAll(".global-tab");
        this.currentItem = this.tabs[0]
        this.updateSlider();

        const swiperContainer = document.querySelector(
          "#" + this.dataset.swiperId
        )?.swiper;

        swiperContainer.on("slideChange", (e) => {
          this.currentItem = this.tabs[e.activeIndex]
          this.updateSlider();
        });
        this.tabs.forEach((item, index) => {
          item.addEventListener("click", () => {
            if (this.currentItem == item) return
            swiperContainer.slideTo(index);
            this.currentItem = item
            this.updateSlider();
          });
        });

        document.addEventListener("windowResize", () => {
          this.updateSlider()
        })
      }
      updateSlider() {
        this.currentItem.classList.add("active");
        $(this.tabs).not(this.currentItem).removeClass("active");
        const { offsetLeft, offsetWidth } = this.currentItem;
        $(this).css({
          ["--global-tab-left"]: offsetLeft + "px",
          ["--global-tab-width"]: offsetWidth + "px",
        });
      }
    }
  );
  customElements.define("section-product-navs", class SectionProductNavs extends HTMLElement {
    constructor() {
      super()
      this.header = document.querySelector(".header__container")
      this.navContainer = document.querySelector(".section-product-navs--sticky")
      this.swiper = this.querySelector("swiper-component")?.swiper ?? {}
      this.init()
      this.listenerScroll()
    }
    init() {
      this.targetElements = Array.from(document.querySelectorAll(".section-anchor-target"))
      this.slides = Array.from(this.querySelectorAll(".slide-navs--item"))
      this.slides.forEach((t, index) => {
        t.onclick = () => {
          this.swiper.slideTo(index)
          this.toTarget(index)
        }
      })
    }
    listenerScroll() {
      window.addEventListener(
        "scroll",
        debounce(() => {
          if (this.header) {
            this.updateElementTopValue()
          }
        }, 1)

      );
    }
    toTarget(index) {
      const anchor = this.targetElements?.[index]
      anchor?.scrollIntoView({ block: 'start', behavior: 'smooth' })
    }
    updateElementTopValue() {
      if (this.isScrollDown()) {
        this.navContainer.style.top = 0
        this.header.style.top = `-${this.header.clientHeight}px`
      } else {
        this.header.style.top = 0
        this.navContainer.style.top = `${this.header.clientHeight - 1}px`
      }
    }
    isScrollDown() {
      const scrollY = this.getScrollTop();
      let delta = scrollY - this.curScrollY;
      this.curScrollY = scrollY
      return delta > 0;
    }
    getScrollTop() {
      return (
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.scrollY ||
        0
      );
    }

  })

  customElements.define("section-product-navs-scroll", class SectionProductNavsScroll extends HTMLElement {
    constructor() {
      super()
      this.header = document.querySelector(".header__container")
      this.navContainer = this.querySelector(".section-product-navs-scroll-bar")
      this.swiper = this.querySelector("swiper-component")?.swiper ?? {}
      this.showThreshold = this.getShowThreshold()
      this.init()
      this.listenerScroll()
    }
    init() {
      this.targetElements = Array.from(document.querySelectorAll(".section-anchor-target"))
      this.slides = Array.from(this.querySelectorAll(".slide-navs--item"))
      this.slides.forEach((t, index) => {
        t.onclick = () => {
          this.swiper.slideTo(index)
          this.toTarget(index)
        }
      })
    }
    getShowThreshold() {
      const headerLayout = document.querySelector(".section-product-header-layout")
      if (headerLayout) {
        const section = headerLayout.closest(".shopify-section")
        if (section) {
          return section.offsetTop + section.offsetHeight
        }
        return headerLayout.offsetTop + headerLayout.offsetHeight
      }
      const anchor = document.querySelector(".section-anchor-target")
      if (anchor) {
        const section = anchor.closest(".shopify-section")
        if (section) {
          return section.offsetTop
        }
        return anchor.offsetTop
      }
      return 400
    }
    listenerScroll() {
      window.addEventListener(
        "scroll",
        debounce(() => {
          this.updateVisibility()
          if (this.header && this.navContainer?.classList.contains("is-visible")) {
            this.updateElementTopValue()
          }
        }, 1)
      )
    }
    updateVisibility() {
      if (!this.navContainer) return
      const show = this.getScrollTop() > this.showThreshold
      this.navContainer.classList.toggle("is-visible", show)
      this.navContainer.setAttribute("aria-hidden", show ? "false" : "true")
      if (!show) {
        if (this.header) {
          this.header.style.top = "0"
        }
        this.navContainer.style.top = ""
      }
    }
    toTarget(index) {
      const anchor = this.targetElements?.[index]
      anchor?.scrollIntoView({ block: "start", behavior: "smooth" })
    }
    updateElementTopValue() {
      if (this.isScrollDown()) {
        this.navContainer.style.top = "0"
        this.header.style.top = `-${this.header.clientHeight}px`
      } else {
        this.header.style.top = "0"
        this.navContainer.style.top = `${this.header.clientHeight - 1}px`
      }
    }
    isScrollDown() {
      const scrollY = this.getScrollTop()
      let delta = scrollY - this.curScrollY
      this.curScrollY = scrollY
      return delta > 0
    }
    getScrollTop() {
      return (
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.scrollY ||
        0
      )
    }
  })

  customElements.define("slide-navs", class SlideNavs extends HTMLElement {
    constructor() {
      super()
      this.swiper = this.querySelector("swiper-component")?.swiper ?? {}
      this.header = document.querySelector(".header__container")
      this.navContainer = document.querySelector(".slide-navs__container")
      this.init()
      this.listenerScroll()
    }
    init() {
      this.slides = Array.from(this.querySelectorAll(".slide-navs--item"))
      this.targetElements = Array.from(document.querySelectorAll(".section-anchor-target"))
      this.slides.forEach((t, index) => {
        t.onclick = () => {
          // this.selectActive(index)
          this.toTarget(index)
        }
      })
      this.selectActive(0)
    }
    selectActive(index) {
      const currentItem = this.slides[index]
      this.slides.filter(p => p != currentItem).forEach(p => p.classList.remove('active'))
      currentItem.classList.add("active")
    }
    listenerScroll() {
      window.addEventListener(
        "scroll",
        debounce(() => {
          this.targetElements.forEach((t, index) => {
            if (t.getBoundingClientRect().top < 500) {
              this.selectActive(index)
              this.swiper?.slideTo(index)
            }
          })
          if (this.header) {
            this.updateElementTopValue()
          }
        }, 1)

      );
    }
    updateElementTopValue() {
      if (this.isScrollDown()) {
        this.navContainer.style.top = 0
        this.header.style.top = `-${this.header.clientHeight}px`
      } else {
        this.header.style.top = 0
        this.navContainer.style.top = `${this.header.clientHeight - 1}px`
      }
    }
    isScrollDown() {
      const scrollY = this.getScrollTop();
      let delta = scrollY - this.curScrollY;
      this.curScrollY = scrollY
      return delta > 0;
    }
    getScrollTop() {
      return (
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.scrollY ||
        0
      );
    }
    toTarget(index) {
      const anchor = this.targetElements?.[index]
      anchor?.scrollIntoView({ block: 'start', behavior: 'smooth' })
    }
  })

  class VideoLazyLoad extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.video = this.querySelector(".video--lazyLoad");
      // 人机是否有交互
      this.interactState = false;
      this.autoplayMap = [];
      // this.listenerIntersectionObserver()
      this.listenerInteract();
      this.listenerALick();
    }

    listenerIntersectionObserver() {
      const _this = this;
      this.videoObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach((entry) => {
          let video = entry.target;
          if (entry.isIntersecting) {
            video.src = video.dataset.src;
            if (video.dataset.poster) {
              video.poster = video.dataset.poster;
            }
            if (video.dataset.autoplay) {
              // 有交互性则自动播放
              video.play();
              // _this.interactState ? video.play() : _this.autoplayMap.push(video)
            }

            // observer.unobserve(entry.target);
          } else {
            // 不在可视区暂停播放
            video.src && video.pause();
          }
        });
      });

      this.videoObserver.observe(this.video);
      //   this.videos.forEach((item) => {
      //     this.videoObserver.observe(item);
      //   });
    }
    listenerInteract() {
      const startEvent = () => {
        this.listenerIntersectionObserver();
        // this.interactState = true
        // this.autoplayMap.forEach(video => video.play())
      };
      document.addEventListener("mousemove", startEvent, { once: true });
      document.addEventListener("touchstart", startEvent, { once: true });
    }

    listenerALick() {
      document.addEventListener("click", (event) => {
        if (
          event.target.tagName === "A" &&
          event.target.getAttribute("href") &&
          this.video
        ) {
          //   this.videos.forEach((video) => video.pause());
          this.video.pause();
        }
      });
    }
  }
  customElements.define("video-lazy-load", VideoLazyLoad);

  customElements.define("youtube-lazy-load", class YoutubeLazyLoad extends HTMLElement {
    constructor() {
      super()
      this.youtubeSection = this.querySelector('.youtube-lazy--section')
      this.createScript()
      const _this = this
      document.addEventListener("youTubeReady", () => {
        console.log("YouTube API 已加载");
        _this.scrollView()
      })
    }
    scrollView() {
      const _this = this
      const observer = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!entry.target.playVideo) {
              _this.init(entry.target)
            }
          } else {
            entry.target.pauseVideo?.()
          }
        });
      });
      observer.observe(this.youtubeSection)
    }
    init(section) {
      if (section.playVideo) return;
      if (window.YT) {
        const target = section.querySelector('.youtube-lazy--load')
        const playe = new window.YT.Player(target, {
          ...target.dataset
        });
        section.playVideo = function () {
          playe.playVideo?.()
        }
        section.pauseVideo = function () {
          playe.pauseVideo?.()
        }
      }
    }
    disconnectedCallback() {
      // this.modalContainer.removeEventListener("click")
    }

    createScript() {
      const scriptTags = Array.from(document.getElementsByTagName('script'));
      const youtubeScript = scriptTags.find(t => t.src == "https://www.youtube.com/player_api")
      if (!youtubeScript) {
        let tag = document.createElement('script');
        tag.src = "https://www.youtube.com/player_api";
        scriptTags[0].parentNode.insertBefore(tag, scriptTags[0]);
        console.log('新加载')
        window.onYouTubeIframeAPIReady = function () {
          document.dispatchEvent(new CustomEvent("youTubeReady", {}))
        }
      } else {
        this.scrollView(this)
      }
    }
  })

  customElements.define("slide-toggle", class SlideToggle extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init() {
      this.footerLinks = this.querySelectorAll('.slide-toggle--item');
      this.addEventListeners();
    }
    addEventListeners() {
      this.footerLinks.forEach((link) => {
        link.addEventListener('click', () => {
          link.classList.toggle('active');
          $(link.nextElementSibling).slideToggle(300);
        });
      });
    }
  });

  class CountDown extends HTMLElement {
    constructor() {
      super();
      this.initDayjs();
      this.init();
    }

    // 初始化 dayjs 插件
    initDayjs() {
      dayjs.extend(window.dayjs_plugin_utc);
      dayjs.extend(window.dayjs_plugin_timezone);
    }

    init() {
      const {
        numberClass,
        downEndTime,
        timeZones = "America/Los_Angeles",
      } = this.dataset;

      if (!downEndTime) {
        console.error("⛔ CountDown 缺少 downEndTime！");
        return;
      }
      this.timeDoms = this.querySelectorAll(`.${numberClass}`);
      this.timeZones = timeZones;
      this.downEndTime = downEndTime;

      this.setTargetTime();
      this.start();
    }

    // 设置目标结束时间戳
    setTargetTime() {
      this.setTime = this.getTargetTime(this.downEndTime).valueOf();
      console.log("⏳ CountDown 目标时间:", this.setTime, "当前时区:", this.timeZones);
    }

    // 启动倒计时
    start() {
      this.stop();
      this.intervalTime = setInterval(this.updateCountdown.bind(this), 1000);
      this.updateCountdown(); // 立即执行一次，避免初始延迟
    }

    // 停止倒计时
    stop() {
      if (this.intervalTime) {
        clearInterval(this.intervalTime);
        this.intervalTime = null;
      }
    }

    // 当前时区时间
    getCurrentTime() {
      return dayjs().tz(this.timeZones);
    }

    // 获取指定时区时间（带容错）
    getTargetTime(time) {
      if (!time) return this.getCurrentTime();

      let parsed = dayjs.tz(time, this.timeZones);

      // 容错：支持 YYYY/MM/DD 格式
      if (!parsed.isValid()) {
        parsed = dayjs.tz(time.replace(/-/g, "/"), this.timeZones);
      }

      if (!parsed.isValid()) {
        console.error("⛔ Invalid time:", time);
        return this.getCurrentTime();
      }

      return parsed;
    }

    // 倒计时逻辑
    updateCountdown() {
      const now = this.getCurrentTime().valueOf();
      let remainingSeconds = Math.floor((this.setTime - now) / 1000);
      // 倒计时结束
      if (remainingSeconds <= 0) {
        this.stop();
        if (document.getElementById(`coupon-${this.dataset.removeId}`)) {
          document.getElementById(`coupon-${this.dataset.removeId}`).remove();
        }
        //触发倒计时结束事件
        this.dispatchEvent(new CustomEvent("countdown:end", {
          bubbles: true,
          composed: true
        }));
        return;
      }

      // 转换为 d/h/m/s 或总小时 h/m/s
      if (this.dataset.totalHours === 'true' && this.timeDoms.length >= 4) {
        const totalH = Math.floor(remainingSeconds / 3600);
        const m = Math.floor((remainingSeconds / 60) % 60);
        const s = Math.floor(remainingSeconds % 60);
        this.timeDoms[0].innerText = '00';
        this.timeDoms[1].innerText = String(totalH).padStart(2, '0');
        this.timeDoms[2].innerText = String(m).padStart(2, '0');
        this.timeDoms[3].innerText = String(s).padStart(2, '0');
        return;
      }

      const d = Math.floor(remainingSeconds / 86400);
      const h = Math.floor((remainingSeconds / 3600) % 24);
      const m = Math.floor((remainingSeconds / 60) % 60);
      const s = Math.floor(remainingSeconds % 60);

      // 渲染到页面
      if (this.timeDoms?.length) {
        const values = [d, h, m, s].map(v => String(v).padStart(2, "0"));
        this.timeDoms.forEach((dom, i) => (dom.innerText = values[i]));
      }
    }
  }
  customElements.define("count-down", CountDown);

  customElements.define("header-navigation", class headerNavigation extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      this.menuItems = Array.from(this.querySelectorAll(".header-menu-item"));
      let firstHover = true;

      this.menuItems.forEach(item => {
        const dropdown = item.querySelector(".header-menu-dropdown");
        const leftNavs = Array.from(item.querySelectorAll(".header-menu-item-left-nav"));
        const contents = Array.from(item.querySelectorAll(".header-menu-item-content"));

        if (!dropdown) {
          item.addEventListener("mouseenter", () => {
            this._hideBackdrop();
          });
          return;
        }

        // 左侧导航切换事件（mega menu；卡片模式无 left-nav）
        leftNavs.forEach((leftNav, index) => {
          leftNav.addEventListener("mouseenter", () => {
            leftNavs.forEach((nav, i) => {
              nav.classList.toggle("active", i === index);
              contents[i].classList.toggle("active", i === index);
            });
          });
        });

        item.addEventListener("mouseenter", () => {
          const duration = firstHover ? 200 : 0;
          $(dropdown).stop(true, true).slideDown(duration, "linear", () => {
            this._showBackdrop(dropdown);
          });
          firstHover = false;

          if (leftNavs.length && !leftNavs.some(nav => nav.classList.contains("active"))) {
            leftNavs[0].classList.add("active");
            if (contents[0]) contents[0].classList.add("active");
          }
        });

        item.addEventListener("mouseleave", () => {
          $(dropdown).stop(true, true).slideUp(0);
        });
      });

      const menuDesktop = this.querySelector('.header-menu-desktop');
      if (menuDesktop) {
        menuDesktop.addEventListener("mouseleave", () => {
          firstHover = true;
          this._hideBackdrop();
        });
      }
    }

    _showBackdrop(dropdown) {
      const backdrop = this.querySelector('.header-menu-backdrop');
      if (!backdrop || !dropdown) return;
      backdrop.style.top = dropdown.getBoundingClientRect().bottom + 'px';
      backdrop.classList.add('is-visible');
    }

    _hideBackdrop() {
      const backdrop = this.querySelector('.header-menu-backdrop');
      if (backdrop) {
        backdrop.classList.remove('is-visible');
      }
    }


    listenerIntersectionObserver() {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 100) {
          this.querySelector('.header-v2--container').classList.remove('is--index')
        } else {
          this.querySelector('.header-v2--container').classList.add('is--index')
        }
      });
    }
  });

  customElements.define("header-navigation-mobile", class headerNavigationMobile extends HTMLElement {
    constructor() {
      super();
      this.trigger = null;
      this._onTriggerClick = this._onTriggerClick.bind(this);
      this._onDocKeydown = this._onDocKeydown.bind(this);
      this._syncOverlayTop = this._syncOverlayTop.bind(this);
      this.init();
      this.initControls();
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener("click", this._onTriggerClick);
      document.removeEventListener("keydown", this._onDocKeydown);
      this._unbindOverlayTop();
      this._setBodyScrollLock(false);
      document.body.classList.remove("header-mobile-nav-open");
    }

    init() {
      this.querySelectorAll("[data-header-nav-l1-trigger]").forEach((el) => {
        el.addEventListener("click", () => this._toggleL1(el));
        el.addEventListener("keydown", (e) => this._onAccordionKeydown(e, () => this._toggleL1(el)));
      });
      this.querySelectorAll("[data-header-nav-l2-trigger]").forEach((el) => {
        el.addEventListener("click", () => this._toggleL2(el));
        el.addEventListener("keydown", (e) => this._onAccordionKeydown(e, () => this._toggleL2(el)));
      });
      this.querySelectorAll("[data-header-locale-trigger]").forEach((el) => {
        el.addEventListener("click", () => this._toggleLocale(el));
        el.addEventListener("keydown", (e) => this._onAccordionKeydown(e, () => this._toggleLocale(el)));
      });
    }

    _onAccordionKeydown(e, toggle) {
      if (e.key !== "Enter" && e.key !== " ") return;
      e.preventDefault();
      toggle();
    }

    initControls() {
      this.trigger = document.querySelector("#header-menu-mobile-open");
      this.trigger?.addEventListener("click", this._onTriggerClick);
    }

    _onTriggerClick(e) {
      e.preventDefault();
      if (this.hasAttribute("open")) {
        this.close();
      } else {
        this.open();
      }
    }

    _onDocKeydown(e) {
      if (e.key === "Escape" && this.hasAttribute("open")) {
        this.close();
      }
    }

    _legacyHeaderRow() {
      return document.querySelector(".header-v2--legacy .header-v2--container > .ts-container");
    }

    _syncOverlayTop() {
      const row = this._legacyHeaderRow();
      if (!row) return;
      const top = Math.max(0, Math.round(row.getBoundingClientRect().bottom));
      document.documentElement.style.setProperty("--header-mobile-overlay-top", `${top}px`);
    }

    _bindOverlayTop() {
      this._syncOverlayTop();
      window.addEventListener("scroll", this._syncOverlayTop, { passive: true });
      window.addEventListener("resize", this._syncOverlayTop, { passive: true });
    }

    _unbindOverlayTop() {
      window.removeEventListener("scroll", this._syncOverlayTop);
      window.removeEventListener("resize", this._syncOverlayTop);
    }

    open() {
      this.setAttribute("open", "");
      this._syncTrigger(true);
      this._setBodyScrollLock(true);
      this._forceSolidHeader();
      this._bindOverlayTop();
      document.addEventListener("keydown", this._onDocKeydown);
    }

    close() {
      this.removeAttribute("open");
      this._syncTrigger(false);
      this._setBodyScrollLock(false);
      document.removeEventListener("keydown", this._onDocKeydown);
      this._unbindOverlayTop();
      this._collapseAll();
      this._restoreHeaderAfterMenu();
    }

    _syncTrigger(isOpen) {
      if (!this.trigger) return;
      this.trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
      this.trigger.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
    }

    _setBodyScrollLock(locked) {
      document.body.style.overflow = locked ? "hidden" : "";
    }

    _forceSolidHeader() {
      document.body.classList.add("header-mobile-nav-open");
      const legacy = document.querySelector(".header-v2--legacy .header-v2--container");
      legacy?.classList.remove("is--index");

      const headerNav = document.querySelector("header-navigation");
      if (!headerNav) return;

      const logoImg = legacy?.querySelector(".header-logo-img");
      const defaultLogo = headerNav.dataset.defaultLogo;
      if (logoImg && defaultLogo) {
        logoImg.src = defaultLogo;
      }
      if (headerNav.dataset.defaultFontColor) {
        headerNav.style.setProperty(
          "--default-header-font-color",
          headerNav.dataset.defaultFontColor
        );
      }
    }

    _restoreHeaderAfterMenu() {
      document.body.classList.remove("header-mobile-nav-open");
      const indexHeaderNav = document.querySelector("header-navigation[data-is-index]");
      const legacy = document.querySelector(".header-v2--legacy .header-v2--container");

      // Non-index pages (e.g. PDP) must never get floating is--index
      if (!indexHeaderNav) {
        legacy?.classList.remove("is--index");
        return;
      }

      const sync = window.__homeBannerHeaderSync;
      if (sync && typeof sync.applyForCurrentState === "function") {
        sync.applyForCurrentState();
        return;
      }

      if (!legacy) return;
      legacy.classList.toggle("is--index", window.scrollY <= 50);
    }

    _collapseAll() {
      this.querySelectorAll("[data-header-nav-l1-trigger][aria-expanded='true']").forEach((btn) => {
        this._setExpanded(btn, btn.closest("[data-header-nav-l1]")?.querySelector("[data-header-nav-l1-panel]"), false);
      });
      this.querySelectorAll("[data-header-nav-l2-trigger][aria-expanded='true']").forEach((btn) => {
        this._setExpanded(btn, btn.closest("[data-header-nav-l2]")?.querySelector("[data-header-nav-l2-panel]"), false);
      });
      this.querySelectorAll("[data-header-locale-trigger][aria-expanded='true']").forEach((btn) => {
        this._setExpanded(btn, btn.closest("[data-header-locale]")?.querySelector("[data-header-locale-panel]"), false);
      });
    }

    _toggleL1(btn) {
      const item = btn.closest("[data-header-nav-l1]");
      const panel = item?.querySelector("[data-header-nav-l1-panel]");
      if (!panel) return;
      const willOpen = btn.getAttribute("aria-expanded") !== "true";

      this.querySelectorAll("[data-header-nav-l1-trigger]").forEach((other) => {
        if (other === btn) return;
        const otherPanel = other.closest("[data-header-nav-l1]")?.querySelector("[data-header-nav-l1-panel]");
        this._setExpanded(other, otherPanel, false);
      });

      this._setExpanded(btn, panel, willOpen);
    }

    _toggleL2(btn) {
      const item = btn.closest("[data-header-nav-l2]");
      const panel = item?.querySelector("[data-header-nav-l2-panel]");
      if (!panel) return;
      const willOpen = btn.getAttribute("aria-expanded") !== "true";
      this._setExpanded(btn, panel, willOpen);
      if (willOpen) {
        requestAnimationFrame(() => this._refreshSwipers(panel));
      }
    }

    _toggleLocale(btn) {
      const item = btn.closest("[data-header-locale]");
      const panel = item?.querySelector("[data-header-locale-panel]");
      if (!panel) return;
      const willOpen = btn.getAttribute("aria-expanded") !== "true";
      if (willOpen) {
        this._ensureLocalePanel(panel);
      }
      this._setExpanded(btn, panel, willOpen);
    }

    _ensureLocalePanel(panel) {
      if (!panel || panel.childElementCount > 0) return;
      const template = document.getElementById("ts-header-locale-panel");
      if (!template?.content) return;
      panel.appendChild(template.content.cloneNode(true));
    }

    _setExpanded(btn, panel, expanded) {
      if (!btn) return;
      btn.setAttribute("aria-expanded", expanded ? "true" : "false");
      btn.classList.toggle("is-expanded", expanded);
      if (panel) {
        panel.hidden = !expanded;
      }
    }

    _refreshSwipers(root) {
      root?.querySelectorAll("swiper-component").forEach((el) => {
        if (!el.swiper) {
          el.setAttribute("open", "");
          return;
        }
        if (typeof el.swiper.update === "function") {
          el.swiper.update();
        }
      });
    }
  })

  customElements.define("product-quantity", class SectionProductHeader extends GlobalHTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      const minusButton = this.querySelector("[data-product-quantity-minus]")
      const plusButton = this.querySelector("[data-product-quantity-plus]")
      const input = this.querySelector("input[name='quantity']")
      if (!minusButton || !plusButton || !input) return
      minusButton.addEventListener("click", () => {
        if (input.disabled || minusButton.disabled) return
        let value = parseInt(input.value) || 1
        if (value > 1) {
          input.value = value - 1
          input.dispatchEvent(new Event('input', { bubbles: true }))
        }
      })
      plusButton.addEventListener("click", () => {
        if (input.disabled || plusButton.disabled) return
        let value = parseInt(input.value) || 0
        if (value < 9999) {
          input.value = value + 1
          input.dispatchEvent(new Event('input', { bubbles: true }))
        }
      })
    }
  })

  function pdpGalleryIsDesktop() {
    return window.matchMedia("(min-width: 768px)").matches
  }

  function pdpGallerySlideToIndex(swiper, index) {
    if (!swiper || index == null || index < 0) return
    const max = Math.max(0, (swiper.slides?.length || 1) - 1)
    swiper.slideTo(Math.min(index, max), 0)
  }

  function pdpGalleryReorderByKeys(container, orderedKeys) {
    if (!container || !orderedKeys?.length) return
    const map = new Map()
    Array.from(container.children).forEach((el) => {
      const key = el.dataset?.galleryKey
      if (key) map.set(key, el)
    })
    orderedKeys.forEach((key) => {
      const el = map.get(key)
      if (el) container.appendChild(el)
    })
  }

  function pdpGallerySlideToVisible(swiper, direction) {
    if (!swiper) return
    const slides = Array.from(swiper.slides || [])
    if (!slides.length) return
    let idx = swiper.activeIndex
    for (let step = 0; step < slides.length; step++) {
      idx += direction
      if (idx < 0 || idx >= slides.length) return
      if (!slides[idx].classList?.contains("is-gallery-hidden")) {
        pdpGallerySlideToIndex(swiper, idx)
        return
      }
    }
  }

  function setupPdpGalleryDesktopBehavior(swiper, component, gallery) {
    if (!swiper || swiper.__pdpGalleryDesktop) return
    swiper.__pdpGalleryDesktop = true

    const dragThreshold = 28
    let dragStartX = 0
    let dragPointerId = null

    // Match Anker: advance one slide at a time (not paired page anchors).
    const gotoSlide = (direction) => {
      pdpGallerySlideToVisible(swiper, direction)
    }

    const applyTouchMode = () => {
      const desktop = pdpGalleryIsDesktop()
      swiper.params.simulateTouch = !desktop
      swiper.allowTouchMove = !desktop
    }
    applyTouchMode()
    window.matchMedia("(min-width: 768px)").addEventListener("change", applyTouchMode)

    const isInteractiveTarget = (target) =>
      target?.closest?.(
        "[data-product-gallery-zoom], .swiper-button-next, .swiper-button-prev, .swiper-pagination-bullet, .product-header-gallery__thumbs, .product-header-gallery__footer"
      )

    const stage = component.querySelector(".product-header-gallery__stage")
    const thumbsRoot = component.querySelector(".product-header-gallery__thumbs")

    const onPointerDown = (event) => {
      if (!pdpGalleryIsDesktop()) return
      if (event.button !== 0) return
      if (isInteractiveTarget(event.target)) return
      event.preventDefault()
      dragStartX = event.clientX
      dragPointerId = event.pointerId
      swiper.__pdpDragging = false
      stage?.setPointerCapture?.(event.pointerId)
    }

    const onPointerMove = (event) => {
      if (!pdpGalleryIsDesktop() || event.pointerId !== dragPointerId) return
      if (Math.abs(event.clientX - dragStartX) > 8) {
        swiper.__pdpDragging = true
        stage?.classList.add("is-dragging")
      }
    }

    const releasePointer = (event) => {
      if (stage?.hasPointerCapture?.(event.pointerId)) {
        stage.releasePointerCapture(event.pointerId)
      }
    }

    const finishPointerDrag = (event) => {
      if (!pdpGalleryIsDesktop() || event.pointerId !== dragPointerId) return
      dragPointerId = null
      stage?.classList.remove("is-dragging")
      releasePointer(event)
      if (!swiper.__pdpDragging) return
      swiper.__pdpDragging = false
      const dx = event.clientX - dragStartX
      if (Math.abs(dx) < dragThreshold) return
      gotoSlide(dx < 0 ? 1 : -1)
    }

    if (stage) {
      stage.addEventListener("pointerdown", onPointerDown, true)
      stage.addEventListener("pointermove", onPointerMove, true)
      stage.addEventListener("pointerup", finishPointerDrag, true)
      stage.addEventListener("pointercancel", finishPointerDrag, true)
    }

    if (thumbsRoot && gallery) {
      thumbsRoot.addEventListener(
        "click",
        (event) => {
          if (!pdpGalleryIsDesktop()) return
          const slide = event.target.closest(".swiper-slide")
          if (!slide || slide.classList.contains("is-gallery-hidden")) return
          const key = slide.dataset.galleryKey
          if (!key) return
          const mainSlide = gallery.querySelector(
            `#swiper-thumbs--image .product-header-gallery__stage .swiper-slide[data-gallery-key="${CSS.escape(key)}"]`
          )
          if (!mainSlide || mainSlide.classList.contains("is-gallery-hidden")) return
          const idx = Array.from(swiper.slides || []).indexOf(mainSlide)
          if (idx < 0) return
          event.preventDefault()
          event.stopImmediatePropagation()
          gallery.slideToMediaIndex(idx)
        },
        true
      )
    }

    component.querySelector(".swiper-button-next")?.addEventListener(
      "click",
      (event) => {
        if (!pdpGalleryIsDesktop()) return
        event.preventDefault()
        event.stopImmediatePropagation()
        gotoSlide(1)
      },
      true
    )

    component.querySelector(".swiper-button-prev")?.addEventListener(
      "click",
      (event) => {
        if (!pdpGalleryIsDesktop()) return
        event.preventDefault()
        event.stopImmediatePropagation()
        gotoSlide(-1)
      },
      true
    )
  }

  customElements.define("product-gallery", class ProductGallery extends HTMLElement {
    constructor() {
      super()
      this.items = []
      this.currentIndex = 0
      this.imageSwiper = null
      this.lightbox = null
      this._onSwiperReady = this._onSwiperReady.bind(this)
      this._initLightbox = this._initLightbox.bind(this)
    }

    connectedCallback() {
      this.zoomBtn = this.querySelector("[data-product-gallery-zoom]")
      this.dialog = this.querySelector("[data-product-gallery-lightbox]")
      this.collectItems()
      this.bindZoom()
      this.bindFooterInteraction()
      this._initLightbox()
      window.addEventListener("product-gallery-lightbox:ready", this._initLightbox)
      document.addEventListener("swiper-component:ready", this._onSwiperReady)
      const imageComponent = this.querySelector("#swiper-thumbs--image")
      if (imageComponent?.swiper) {
        this.attachImageSwiper(imageComponent.swiper)
      }
    }

    disconnectedCallback() {
      document.removeEventListener("swiper-component:ready", this._onSwiperReady)
      window.removeEventListener("product-gallery-lightbox:ready", this._initLightbox)
      this.lightbox?.destroy()
      this.lightbox = null
    }

    _initLightbox() {
      if (!this.dialog || this.lightbox || !window.ProductGalleryLightbox) return
      this.lightbox = new window.ProductGalleryLightbox(this)
      this.lightbox.init()
      if (this.imageSwiper) {
        this.lightbox.setImageSwiper(this.imageSwiper)
      }
    }

    _onSwiperReady(event) {
      const { swiperComponent, swiper } = event.detail
      if (swiperComponent?.id === "swiper-thumbs--image" && this.contains(swiperComponent)) {
        this.attachImageSwiper(swiper)
      }
    }

    attachImageSwiper(swiper) {
      if (this.imageSwiper === swiper) return
      this.imageSwiper = swiper
      this.currentIndex = swiper.activeIndex
      this.lightbox?.setImageSwiper(swiper)
      const imageComponent = this.querySelector("#swiper-thumbs--image")
      if (imageComponent) {
        setupPdpGalleryDesktopBehavior(swiper, imageComponent, this)
      }
      swiper.on("slideChange", () => {
        this.currentIndex = swiper.activeIndex
        this.lightbox?.syncFromMainSwiper(this.currentIndex)
      })
      // Mobile: tap main image to open lightbox (Swiper click skips swipe gestures)
      swiper.on("click", (_swiper, event) => {
        if (pdpGalleryIsDesktop()) return
        if (
          event.target?.closest?.(
            ".swiper-pagination-bullet, .product-header-gallery__footer, .product-header-gallery__thumbs, [data-product-gallery-zoom]"
          )
        ) {
          return
        }
        if (!this.items.length) return
        this.lightbox?.open(swiper.activeIndex ?? 0)
      })
    }

    slideToMediaIndex(mediaIndex) {
      if (!this.imageSwiper) return
      const targetIndex = Number(mediaIndex)
      pdpGallerySlideToIndex(this.imageSwiper, targetIndex)
      this.currentIndex = targetIndex
    }

    collectItems() {
      this.items = Array.from(
        this.querySelectorAll(
          "#swiper-thumbs--image .product-header-gallery__stage .swiper-slide[data-full-src]:not(.is-gallery-hidden)"
        )
      ).map((slide) => ({
        src: slide.dataset.fullSrc,
        alt: slide.dataset.alt || "",
      }))
    }

    setMediaMode(mode) {
      if (!this.zoomBtn) return
      this.zoomBtn.hidden = mode !== "photos"
    }

    bindZoom() {
      if (!this.zoomBtn || !this.dialog) return
      this.zoomBtn.addEventListener("click", () => {
        if (!this.items.length) return
        const index = this.imageSwiper?.activeIndex ?? 0
        this.lightbox?.open(index)
      })
    }

    bindFooterInteraction() {
      const main = this.querySelector(".product-header-gallery__main")
      if (!main) return
      main.addEventListener("mouseleave", () => {
        const active = document.activeElement
        if (active && main.contains(active)) {
          active.blur()
        }
      })
      main.querySelector(".product-header-gallery__thumbs")?.addEventListener("click", (event) => {
        event.target.closest(".swiper-slide")?.blur?.()
      })
    }
  })

  customElements.define("section-product-header", class SectionProductHeader extends HTMLElement {
    constructor() {
      super()
      this.initVariants()
      this.cacheElements()
      this.linearVariantChange()
      this.linearProductForm()
      this.linearSwitch()
      this.initBuyNow()
      this.syncInitialVariantMedia()
    }
    cacheElements() {
      this.cache = {
        price: this.querySelectorAll("[data-variant-price]"),
        crossedPrice: this.querySelectorAll("[data-variant-crossed-price]"),
        discountPrice: this.querySelectorAll("[data-variant-discount-price]"),
        sku: this.querySelector("[data-variant-sku]"),
        masterSelect: this.querySelector("input[name='id']"),
        quantity: this.querySelector('.product-purchase__quantity input[name="quantity"]'),
        form: this.querySelector("form.variations_form") || this.querySelector("form"),
        addCartButtons: this.querySelectorAll("[data-product-add-to-cart]"),
        buyNowLinks: this.querySelectorAll("[data-product-buy-now]"),
        imageSwiper: this.querySelector("#swiper-thumbs--image")?.swiper,
        switchSwiper: this.querySelector("#swiper-thumbs--switch")

      }
    }
    collectPurchaseItems() {
      const mainId = this.cache.masterSelect?.value
      if (!mainId) return null
      const mainQty = Math.max(1, parseInt(this.cache.quantity?.value, 10) || 1)
      const items = [
        {
          id: mainId,
          quantity: mainQty,
        },
      ]
      this.querySelectorAll('[data-recommended-product]').forEach((el) => {
        if (el.dataset.available === 'false') return
        const input = el.querySelector('input.product-recommend-card__checkbox:checked:not(:disabled)')
        if (!input) return
        const quantity = Math.max(1, parseInt(el.querySelector("input[name='quantity']")?.value, 10) || 1)
        items.push({
          id: input.value,
          quantity,
        })
      })
      return { items }
    }
    resolveCurrentVariant() {
      const variantId = this.cache.masterSelect?.value
      return (
        (variantId ? this.getVariantOption(variantId) : null) ||
        this.getInitialVariant() ||
        null
      )
    }
    updateBuyNowLink(variant, { forceDisable = false } = {}) {
      if (!this.cache.buyNowLinks?.length) return
      // Only change disabled state when we have a definite answer.
      // forceDisable: unmatched option combo; available===false: sold out.
      // variant null without forceDisable: leave Liquid/current state alone.
      if (!forceDisable && !variant) return
      const shouldDisable = forceDisable || variant?.available === false
      this.cache.buyNowLinks.forEach((btn) => {
        if (shouldDisable) {
          btn.disabled = true
          btn.setAttribute('aria-disabled', 'true')
        } else {
          btn.disabled = false
          btn.removeAttribute('aria-disabled')
        }
      })
    }
    setBuyNowLoading(isLoading) {
      this.cache.buyNowLinks?.forEach((btn) => {
        btn.classList.toggle('button-loading', isLoading)
        if (isLoading) {
          btn.setAttribute('aria-busy', 'true')
          btn.disabled = true
        } else {
          btn.removeAttribute('aria-busy')
          const variant = this.resolveCurrentVariant()
          if (variant) {
            this.updateBuyNowLink(variant)
          } else {
            btn.disabled = false
          }
        }
      })
    }
    fetchBuyNowCheckout(data) {
      this.setBuyNowLoading(true)
      return fetch(`${Shopify.routes.root}cart/add.js`, {
        body: JSON.stringify(data),
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json"
        }
      }).then(async (response) => {
        if (!response.ok) {
          let message = 'Error adding to cart. Please try again.'
          try {
            const err = await response.json()
            if (err?.description) message = err.description
          } catch (_) {}
          throw new Error(message)
        }
        const root = Shopify.routes.root || '/'
        window.location.href = `${root}checkout`
      }).catch((error) => {
        alert(error?.message || 'Error adding to cart. Please try again.')
        this.setBuyNowLoading(false)
      })
    }
    initBuyNow() {
      this.cache.buyNowLinks?.forEach((btn) => {
        btn.addEventListener('click', (event) => {
          event.preventDefault()
          event.stopPropagation()
          if (btn.getAttribute('aria-busy') === 'true') return
          if (btn.disabled) return

          const variant = this.resolveCurrentVariant()
          if (variant && variant.available === false) return

          const data = this.collectPurchaseItems()
          if (!data?.items?.length) {
            alert('Unable to start checkout. Please try again.')
            return
          }
          this.fetchBuyNowCheckout(data)
        })
      })
      this.updateBuyNowLink(this.resolveCurrentVariant())
    }
    linearProductForm() {
      if (!this.cache.form) return
      this.cache.form.addEventListener('submit', (event) => {
        event.preventDefault();
        const data = this.collectPurchaseItems()
        if (!data?.items?.length) return
        this.fetchAddToCart(data);
      });
    }

    updateAddToCartButtonLoading(isLoading) {
      if (isLoading) {
        this.cache.addCartButtons.forEach(button => {
          button.classList.add("button-loading");
          button.setAttribute("disabled", "disabled");
        });
      } else {
        this.cache.addCartButtons.forEach(button => button.classList.remove("button-loading"));
      }
    }
    updateAddToCartButtonState(state) {
      const buttonData = this.dataset.buttonData ? JSON.parse(this.dataset.buttonData) : {};
      if (state) {
        this.cache.addCartButtons.forEach(button => {
          button.innerText = buttonData.buttonSoldOut || button.innerText;
          button.setAttribute("disabled", "disabled")
        });
      } else {
        this.cache.addCartButtons.forEach(button => {
          button.innerText = buttonData.buttonDefault || button.innerText;
          button.removeAttribute("disabled");
        });
      }
    }
    getCurrentVariantAvailability() {
      const variantId = this.cache.masterSelect?.value
      const variant = variantId ? this.getVariantOption(variantId) : null
      return variant?.available === true
    }
    restoreAddToCartButtonState() {
      this.updateAddToCartButtonState(!this.getCurrentVariantAvailability())
    }
    fetchAddToCart(data) {
      this.updateAddToCartButtonLoading(true)
      attachCartSections(data)
      fetch(`${Shopify.routes.root}cart/add.js`, {
        body: JSON.stringify(data),
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          // Needed for Shopify to check inventory
          "Content-Type": "application/json"
        }
      }).then(async (response) => {
        if (!response.ok) {
          console.error('Error adding to cart:', response);
          alert('Error adding to cart. Please try again.');
          return;
        }
        let payload = {};
        try {
          payload = await response.json();
        } catch (_) {}
        document.dispatchEvent(
          new CustomEvent("ts:cart:updated", {
            bubbles: true,
            detail: {
              source: "add-to-cart",
              sections: payload.sections || {},
              open: hasCartDrawer(),
            },
          })
        );
        fetch(`${Shopify.routes.root}cart.js`, { credentials: "same-origin" })
          .then((cartRes) => cartRes.json())
          .then((cart) => {
            if (typeof cart.item_count === "number") syncHeaderCartCount(cart.item_count)
          })
          .catch(() => {})
          .finally(() => {
            if (!hasCartDrawer()) this.triggerAfterATC(data.items?.[0]?.id);
          })
      }).catch(error => {
        alert('Error adding to cart. Please try again.', JSON.stringify(error));
      }).finally(() => {
        this.updateAddToCartButtonLoading(false)
        this.restoreAddToCartButtonState()
      });
    }
    triggerAfterATC(productId) {
      if (hasCartDrawer()) return;

      const after_action_atc = window.nt_settings?.after_action_atc;
      if (!after_action_atc || after_action_atc === '0') return;

      const cartUrl = window.t_cart_url || '/cart';

      if (after_action_atc === '1') {
        const s = window.nt_settings;
        const html = [
          '<div class="added-to-cart">',
          '<p>' + s.added_to_cart + '</p>',
          '<a href="#" class="btn btn-style-link close-popup">' + s.continue_shopping + '</a>',
          '<a href="' + cartUrl + '" class="button view-cart">' + s.view_cart + '</a>',
          '</div>',
        ].join('');
        if (window.$ && $.magnificPopup) {
          $.magnificPopup.open({
            callbacks: {
              beforeOpen: function() {
                this.st.mainClass = 'mfp-move-horizontal cart-popup-wrapper';
              }
            },
            items: {
              src: '<div class="white-popup add-to-cart-popup popup-added_to_cart">' + html + '</div>',
              type: 'inline'
            }
          });
          $('.white-popup').on('click', '.close-popup', function(e) {
            e.preventDefault();
            $.magnificPopup.close();
          });
        }
      } else if (after_action_atc === '2' || after_action_atc === '3') {
        const openBtn = document.querySelector('[data-ts-cart-open]');
        if (openBtn) openBtn.click();
        else window.location.href = cartUrl;
      } else {
        window.location.href = cartUrl;
      }
    }

    linearVariantChange() {
      this.querySelectorAll("[data-variant-input]").forEach(el => {
        el.addEventListener('change', this.onSelectChange.bind(this));
      });
    }
    getSelectedOptionValues() {
      return this.getSelectedOptionValuesRaw().filter((value) => value != null)
    }
    getSelectedOptionValuesRaw() {
      const fieldsets = Array.from(this.querySelectorAll('.variant-input-fieldset[data-index]'))
      fieldsets.sort((a, b) => {
        const ai = parseInt(String(a.dataset.index).replace('option', ''), 10) || 0
        const bi = parseInt(String(b.dataset.index).replace('option', ''), 10) || 0
        return ai - bi
      })
      return fieldsets.map((fieldset) => {
        const checked = fieldset.querySelector('[data-variant-input]:checked')
        return checked?.value ?? null
      })
    }
    getVariantFromSelectedOptions(selectedValues = this.getSelectedOptionValues()) {
      if (!selectedValues.length || !this.variantJson?.length) return null
      if (selectedValues.some((value) => value == null)) return null
      return this.variantJson.find((variant) => {
        return selectedValues.every((value, index) => {
          return variant[`option${index + 1}`] == value
        })
      }) || null
    }
    formatOptionMoney(cents) {
      if (cents == null || typeof geckoShopify?.formatMoney !== 'function') return ''
      const formatted = geckoShopify.formatMoney(cents)
      const tmp = document.createElement('div')
      tmp.innerHTML = formatted
      return (tmp.textContent || tmp.innerText || formatted).trim()
    }
    getVariantOptionImageUrl(variant, width = 128) {
      const src = variant?.featured_image?.src
      if (!src) {
        return this.querySelector('[data-variant-picker]')?.dataset?.fallbackImage || ''
      }
      try {
        const url = new URL(src, window.location.origin)
        url.searchParams.set('width', String(width))
        return url.toString()
      } catch (_) {
        return src
      }
    }
    updateOptionCards() {
      const selectedValues = this.getSelectedOptionValuesRaw()
      if (!selectedValues.length || !this.variantJson?.length) return

      this.querySelectorAll('[data-variant-option-card]').forEach((card) => {
        const optionIndex = (parseInt(String(card.dataset.index).replace('option', ''), 10) || 1) - 1
        const optionValue = card.dataset.value
        if (optionIndex < 0 || optionValue == null) return

        const candidateValues = selectedValues.slice()
        candidateValues[optionIndex] = optionValue
        const variant = this.getVariantFromSelectedOptions(candidateValues)

        const input = card.querySelector('[data-variant-input]')
        const label = card.querySelector('.variant-option__label')
        if (input) {
          if (variant?.id != null) {
            input.dataset.variantId = String(variant.id)
          } else {
            delete input.dataset.variantId
          }
        }
        if (label) {
          label.classList.toggle('disabled', !variant || variant.available === false)
        }
        if (!variant) return

        const mediaEl = card.querySelector('[data-variant-option-media]')
        if (mediaEl) {
          const imageUrl = this.getVariantOptionImageUrl(variant)
          let img = mediaEl.querySelector('img')
          if (imageUrl) {
            if (!img) {
              mediaEl.querySelector('.variant-option__media-placeholder')?.remove()
              img = document.createElement('img')
              img.className = 'tw-rounded-sm'
              img.width = 128
              img.alt = ''
              mediaEl.appendChild(img)
            }
            if (img.dataset.src != null) {
              img.dataset.src = imageUrl
            }
            img.src = imageUrl
          }
        }

        if (card.dataset.showOptionPrice !== 'true') return

        const priceEl = card.querySelector('[data-variant-option-price]')
        const compareEl = card.querySelector('[data-variant-option-compare]')
        const badgeEl = card.querySelector('[data-variant-option-badge]')
        const discountAmount = (variant.compare_at_price || 0) - (variant.price || 0)
        const hasDiscount = discountAmount > 0

        if (priceEl) {
          priceEl.textContent = this.formatOptionMoney(variant.price)
        }
        if (compareEl) {
          compareEl.classList.toggle('tw-hidden', !hasDiscount)
          if (hasDiscount) {
            compareEl.textContent = this.formatOptionMoney(variant.compare_at_price)
          }
        }
        if (badgeEl) {
          badgeEl.classList.toggle('tw-hidden', !hasDiscount)
          if (hasDiscount) {
            badgeEl.textContent = `${this.formatOptionMoney(discountAmount)} OFF`
          }
        }
      })
    }
    onSelectChange() {
      const variant = this.getVariantFromSelectedOptions()
      if (variant) {
        this.applyVariantChange(variant)
      } else {
        this.updateOptionCards()
        this.updateAddToCartButtonState(true);
        this.updateBuyNowLink(null, { forceDisable: true })
        if (this.cache.masterSelect) {
          this.cache.masterSelect.setAttribute("disabled", "disabled")
        }
      }
    }
    applyVariantChange(variant, { updateUrl = true } = {}) {
      this.currentVariant = variant;
      this.updateAddToCartButtonState(!variant.available);
      this.updateSwiperImages(variant)
      this.updateMasterSelect(variant)
      this.updatePrice(variant)
      this.updateUnitPrice(variant)
      this.updateSKU(variant)
      this.updateBuyNowLink(variant)
      this.updateOptionCards()
      if (updateUrl) {
        this.updateUrlvariantId(variant)
      }
      document.dispatchEvent(new CustomEvent('ts:variant:change', {
        detail: { variant }
      }))
    }
    updateUrlvariantId(variant) {
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      // 不刷新页面更新 URL
      history.replaceState(null, '', url);
    }
    updateSKU(variant) {
      if (!this.cache.sku) return
      this.cache.sku.innerText = variant.sku
    }
    updateUnitPrice() {

    }
    updatePrice(variant) {
      const discount_amount = variant.compare_at_price - variant.price
      this.cache.price.forEach(el => {
        el.innerHTML = geckoShopify.formatMoney(variant.price)
      })
      const hasDiscount = discount_amount > 0
      this.cache.crossedPrice?.forEach(el => {
        el.classList.toggle("tw-hidden", !hasDiscount)
        if (hasDiscount) {
          el.innerHTML = geckoShopify.formatMoney(variant.compare_at_price)
        }
      })
      this.cache.discountPrice?.forEach(el => {
        el.classList.toggle("tw-hidden", !hasDiscount)
        if (hasDiscount) {
          el.querySelector('.discount-amount').innerHTML =
            '-' + geckoShopify.formatMoney(discount_amount)
        }
      })
    }
    initVariants() {
      this.variantJson = JSON.parse(this.querySelector("[data-variant-json]")?.textContent ?? "[]")
      this.currentVariantJson = JSON.parse(this.querySelector("[data-current-variant-json]")?.textContent ?? "{}")
      this.currentVariant = this.currentVariantJson?.id ? this.currentVariantJson : null
      this.initVariantGalleryMeta()
    }
    initVariantGalleryMeta() {
      const el = this.querySelector("[data-variant-gallery-json]")
      try {
        this.galleryMeta = JSON.parse(el?.textContent ?? "{}")
      } catch (_) {
        this.galleryMeta = {}
      }
      if (!Array.isArray(this.galleryMeta.allFeaturedIds)) {
        this.galleryMeta.allFeaturedIds = []
      }
      if (!this.galleryMeta.featuredByVariant || typeof this.galleryMeta.featuredByVariant !== "object") {
        this.galleryMeta.featuredByVariant = {}
      }
    }
    getVariantGalleryMeta() {
      if (!this.galleryMeta) this.initVariantGalleryMeta()
      return this.galleryMeta
    }
    refreshGallerySwipers(imageSwiper) {
      if (!imageSwiper) return
      imageSwiper.update()
      imageSwiper.pagination?.render?.()
      imageSwiper.pagination?.update?.()
      const thumbs = imageSwiper.thumbs?.swiper
      if (thumbs) {
        thumbs.update()
        thumbs.pagination?.render?.()
        thumbs.pagination?.update?.()
      }
      const gallery = this.querySelector("product-gallery")
      gallery?.collectItems?.()
      const lightboxSwiper = gallery?.querySelector("#swiper-lightbox")?.swiper
      if (lightboxSwiper) {
        lightboxSwiper.update()
        lightboxSwiper.pagination?.render?.()
        lightboxSwiper.pagination?.update?.()
      }
    }
    updateSwiperImages(variant) {
      if (!variant) return
      const gallery = this.querySelector("product-gallery")
      const imageComponent = this.querySelector("#swiper-thumbs--image")
      if (!this.cache.imageSwiper) {
        this.cache.imageSwiper = imageComponent?.swiper
      }
      const imageSwiper = this.cache.imageSwiper
      if (!imageSwiper || !gallery) return

      const variantId = String(variant.id)
      const featuredId = this.getFeaturedMediaId(variant)
      const allFeaturedIds = (this.getVariantGalleryMeta().allFeaturedIds || []).map(Number)
      const stageWrapper = gallery.querySelector(
        "#swiper-thumbs--image .product-header-gallery__stage .swiper-wrapper"
      )
      if (!stageWrapper) return

      const stageSlides = Array.from(
        stageWrapper.querySelectorAll(":scope > .swiper-slide[data-gallery-key]")
      )
      if (!stageSlides.length) return

      const hasVariantSet = stageSlides.some(
        (slide) => slide.dataset.gallery === "variant" && slide.dataset.variantId === variantId
      )

      const hiddenByKey = new Map()
      stageSlides.forEach((slide) => {
        const key = slide.dataset.galleryKey
        let hidden = true
        if (hasVariantSet) {
          hidden = !(slide.dataset.gallery === "variant" && slide.dataset.variantId === variantId)
        } else if (slide.dataset.gallery === "product") {
          const mediaId = Number(slide.dataset.mediaId)
          const isForeignFeatured =
            allFeaturedIds.includes(mediaId) &&
            (featuredId == null || mediaId !== Number(featuredId))
          hidden = isForeignFeatured
        }
        hiddenByKey.set(key, hidden)
      })

      gallery.querySelectorAll("[data-gallery-key]").forEach((el) => {
        const key = el.dataset.galleryKey
        if (!hiddenByKey.has(key)) return
        el.classList.toggle("is-gallery-hidden", hiddenByKey.get(key) === true)
      })

      const visibleSlides = stageSlides.filter((slide) => !hiddenByKey.get(slide.dataset.galleryKey))
      const hiddenSlides = stageSlides.filter((slide) => hiddenByKey.get(slide.dataset.galleryKey))
      let targetEl = visibleSlides[0]
      if (!hasVariantSet && featuredId != null) {
        const featuredEl = visibleSlides.find(
          (slide) => Number(slide.dataset.mediaId) === Number(featuredId)
        )
        if (featuredEl) targetEl = featuredEl
      }
      if (!targetEl) return

      const orderedVisible = [targetEl, ...visibleSlides.filter((slide) => slide !== targetEl)]
      const orderedKeys = [...orderedVisible, ...hiddenSlides].map((slide) => slide.dataset.galleryKey)

      const thumbsWrapper = gallery.querySelector(".product-header-gallery__thumbs .swiper-wrapper")
      const lightboxWrapper = gallery.querySelector("#swiper-lightbox .swiper-wrapper")
      const lightboxThumbs = gallery.querySelector("[data-lightbox-thumbs]")

      pdpGalleryReorderByKeys(stageWrapper, orderedKeys)
      pdpGalleryReorderByKeys(thumbsWrapper, orderedKeys)
      pdpGalleryReorderByKeys(lightboxWrapper, orderedKeys)
      pdpGalleryReorderByKeys(lightboxThumbs, orderedKeys)

      Array.from(stageWrapper.querySelectorAll(":scope > .swiper-slide[data-gallery-key]")).forEach(
        (slide, index) => {
          slide.dataset.index = String(index)
          slide.classList.toggle("is-gallery-lead", index === 0 && !slide.classList.contains("is-gallery-hidden"))
        }
      )
      lightboxThumbs?.querySelectorAll("[data-gallery-key]").forEach((thumb, index) => {
        thumb.dataset.lightboxThumb = String(index)
      })

      this.refreshGallerySwipers(imageSwiper)

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.refreshGallerySwipers(imageSwiper)
          pdpGallerySlideToIndex(imageSwiper, 0)
          const thumbs = imageSwiper.thumbs?.swiper
          if (thumbs) pdpGallerySlideToIndex(thumbs, 0)
          const lightboxSwiper = gallery.querySelector("#swiper-lightbox")?.swiper
          if (lightboxSwiper) pdpGallerySlideToIndex(lightboxSwiper, 0)
          gallery.currentIndex = 0
          gallery.lightbox?.syncUI?.(0)
          gallery.collectItems?.()
        })
      })
    }
    updateMasterSelect(variant) {
      this.cache.masterSelect.value = variant.id
      if (variant.available) {
        this.cache.masterSelect.removeAttribute("disabled")
      } else {
        this.cache.masterSelect.setAttribute("disabled", "disabled")
      }
    }
    linearSwitch() {
      const items = Array.from(this.querySelectorAll(".swiper-thumbs--switch-btn"))
      const gallery = this.querySelector("product-gallery")
      items.forEach((item, index) => {
        item.onclick = () => {
          item.classList.add("active")
          items.filter(t => t != item).forEach(t => t.classList.remove("active"))
          this.cache.switchSwiper.slideTo(index)
          gallery?.setMediaMode(index === 0 ? "photos" : "video")
        }
      })
    }
    getVariantOption(variantId) {
      return this.variantJson.find(t => t.id == variantId)
    }
    getFeaturedMediaId(variant) {
      if (!variant) return null
      const fromMeta = this.getVariantGalleryMeta()?.featuredByVariant?.[String(variant.id)]
      if (fromMeta != null && fromMeta !== "") return Number(fromMeta)
      if (variant.featured_media?.id != null) return Number(variant.featured_media.id)
      return null
    }
    getInitialVariant() {
      const matched = this.getVariantFromSelectedOptions()
      if (matched) return matched
      const currentVariantEl = this.querySelector('[data-current-variant-json]')
      if (currentVariantEl?.textContent) {
        try {
          const currentVariant = JSON.parse(currentVariantEl.textContent)
          if (currentVariant?.id) {
            return this.getVariantOption(currentVariant.id) || currentVariant
          }
        } catch (error) {}
      }
      return null
    }
    syncInitialVariantMedia() {
      const run = () => {
        this.cache.imageSwiper = this.querySelector("#swiper-thumbs--image")?.swiper
        const variant = this.getInitialVariant()
        if (variant) {
          this.applyVariantChange(variant, { updateUrl: false })
        }
      }
      if (this.querySelector("#swiper-thumbs--image")?.swiper) {
        run()
        return
      }
      const onReady = (event) => {
        const component = event.detail?.swiperComponent
        if (!component || component.id !== 'swiper-thumbs--image' || !this.contains(component)) {
          return
        }
        document.removeEventListener('swiper-component:ready', onReady)
        run()
      }
      document.addEventListener('swiper-component:ready', onReady)
    }
  })

  customElements.define("add-to-cart-fixed", class AddToCartFixed extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      const _this = this
      let target = null
      if (this.hasAttribute("data-sentinel")) {
        const selector = this.getAttribute("data-sentinel")
        if (!selector) {
          this.setAttribute("open", "")
          return
        }
        target = document.querySelector(selector)
        if (!target) {
          this.setAttribute("open", "")
          return
        }
      } else {
        target = document.querySelector(".product-add-to-cart")
        if (!target) return
      }
      const observerEvent = new IntersectionObserver(function (entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            _this.removeAttribute("open")
          } else {
            _this.setAttribute("open", "")
          }
        })
      })
      observerEvent.observe(target)
    }
  })

  customElements.define("product-coupon", class ProductCoupon extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      this.copyBtn = this.querySelector("[data-copy-btn]");
      if (!this.copyBtn) return;
      this.copyBtnLabel = this.copyBtn.querySelector("[data-copy-btn-text]") || this.copyBtn;
      this.copyBtnText = this.copyBtnLabel.textContent.trim();
      this.copyBtn.addEventListener("click", () => {
        this.copyText(this.dataset.code);
      });
    }

    copyText(text) {
      if (!navigator.clipboard) {
        // 如果不支持 clipboard API，则使用后备方案
        this.fallbackCopyText(text);
        return;
      }

      navigator.clipboard.writeText(text)
        .then(() => {
          this.showCopySuccess();
        })
        .catch(err => {
          console.error('复制失败:', err);
        });
    }
    showCopySuccess() {
      this.copyBtnLabel.textContent = "Copy successful";
      this.setBtnText();
    }
    setBtnText() {
      clearTimeout(this.time)
      this.time = setTimeout(() => {
        this.copyBtnLabel.textContent = this.copyBtnText;
      }, 2000);

    }
    fallbackCopyText(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.showCopySuccess();
    }
  })

  customElements.define("section-home-full", class SectionHomeFull extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      const videoContainer = this.querySelector(".section-home-full-video")
      const video = this.querySelector(".section-home-full-video video")
      if (!video) return
      const play_btn = this.querySelector(".section-home-full-play")
      const pause_btn = this.querySelector(".section-home-full-pause")
      play_btn.onclick = () => {
        video.play()
        play_btn.style.display = "none"
        pause_btn.style.display = "block"
        videoContainer.classList.add("playing")
      }
      pause_btn.onclick = () => {
        video.pause()
        play_btn.style.display = "block"
        pause_btn.style.display = "none"
        videoContainer.classList.remove("playing")
      }

    }
  })

  customElements.define("section-popup", class SectionPopup extends GlobalHTMLElement {
    constructor() {
      super()
      this.show_delay = Number(this.dataset.showDelay ?? 5000) // 首次进入页面五秒后弹出
      this.cool_down_days = Number(this.dataset.coolDownDays ?? 3) // 关闭后 3 天内不再显示
      this.campaign_version = 'popup_' + this.dataset.campaignVersion
      this.initPopupEvent()
      this.initPopup()
      this.listenerClose()
    }
    initPopup() {
      // 提交成功后的直接弹窗
      if (this.checkSuccess()) {
        const popup_items = this.querySelectorAll(".section-popup--item")
        popup_items[0].classList.add("active")
        popup_items[1].classList.remove("active")
        this.showPopup()
        return
      }
      // 检测版本
      if (this.checkCampaignVersion() || !this.isInCoolDown()) {
        this.initOnePopup()
      }
    }

    checkSuccess() {
      const form_id = this.dataset.formId
      const { hash, search } = window.location
      return search.includes("customer_posted=true") && hash.includes(form_id)
    }

    initOnePopup() {
      switch (this.dataset.popupType) {
        case "delay":
          // 用户第一次访问 -> 5秒后弹出
          this.delayPopup()
          break;
        default:
          // 第一次访问滑动30%后弹出
          this.scrollPopup()
          break;
      }
    }
    delayPopup() {
      if (this.time || this.open) return;
      var interactionCleanup = waitForUserInteraction(() => {
        clearTimeout(this.time)
        this.time = setTimeout(() => {
          this.showPopup()
          this.setAttribute("show", "")
        }, this.show_delay);
      });
    }
    initPopupEvent() {
      this.close_btn = this.querySelector(".section-popup-close")
      this.close_btn.onclick = () => {
        this.removePopup()
      }

    }
    getStatus() {
      return JSON.parse(localStorage.getItem('popup_newsletter_status') || '{}');
    }
    setStatus(data) {
      data.campaign_version = this.campaign_version;
      localStorage.setItem('popup_newsletter_status', JSON.stringify(data));
    }
    removePopup() {
      if (this._removing) return;
      this._removing = true;
      this.setStatus({ closedTime: Date.now(), floatVisible: false });

      if (!this.open) {
        this.remove();
        return;
      }

      const container = this.querySelector(".section-popup-container");
      let removed = false;
      const finish = () => {
        if (removed) return;
        removed = true;
        this.remove();
      };

      this.open = false;

      if (container) {
        container.addEventListener("transitionend", finish, { once: true });
        setTimeout(finish, 500);
      } else {
        finish();
      }
    }
    hidePopup() {
      const status = this.getStatus();
      // this.open = false
      // status.floatVisible = true; // 显示浮动按钮
      this.setStatus({ closedTime: Date.now(), floatVisible: false });
      // this.setStatus(status);
    }
    showPopup() {
      // Ensure closed styles paint first so open transitions run
      requestAnimationFrame(() => {
        this.open = true;
      });
    }
    isInCoolDown() {
      const status = this.getStatus();
      if (!status.closedTime) return false;
      return (Date.now() - status.closedTime) < this.cool_down_days * 24 * 60 * 60 * 1000;
    }
    checkCampaignVersion() {
      const status = this.getStatus();
      if (status.campaign_version !== this.campaign_version) {
        // 版本不同 -> 重置状态
        localStorage.removeItem('popup_newsletter_status');
        return true
      }
      return false
    }
    listenerClose() {
      const popup_container = this.querySelector(".section-popup-container")
      popup_container.addEventListener("click", (e) => {
        if (this.open && (e.target == popup_container || e.target == this.querySelector('.section-popup-close'))) {
          this.close_btn.click()
        }
      });
    }
    scrollPopup() {
      this.scrollHandler = () => {
        if (this.scroll_triggered || this.open) return
        const scrollTop = window.scrollY || document.documentElement.scrollTop
        const docHeight = document.documentElement.scrollHeight - window.innerHeight
        const scrollPercent = scrollTop / docHeight
        if (scrollPercent >= 0.3) { // 滚动超过30%
          this.scroll_triggered = true
          clearTimeout(this.time) // 清除5秒延时触发
          this.showPopup()
          this.setAttribute("show", "")
          window.removeEventListener("scroll", this.scrollHandler)
        }
      }
      window.addEventListener("scroll", this.scrollHandler)
    }
  })

  customElements.define("section-host-tabs", class SectionHostTabs extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      const swipers = this.querySelectorAll("swiper-component")
      const tabs = Array.from(this.querySelectorAll(".section-host-tab"))
      tabs.forEach((item, index) => {
        item.onclick = () => {
          item.classList.add('active')
          tabs.filter(t => t != item).forEach(t => t.classList.remove('active'))
          swipers.forEach(swiper => {
            swiper.slideTo(index)
          })
        }
      })
    }
  })

  customElements.define("country-language", class CountryLanguage extends GlobalHTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      const close_btn = this.querySelector(".country-language-close")
      if (close_btn) {
        close_btn.onclick = () => {
          this.open = false
        }
      }
      document.querySelectorAll(".country-language-open").forEach((open_btn) => {
        open_btn.addEventListener("click", () => {
          this.open = true
        })
      })
    }
  })

  // 折叠内容
  customElements.define("collapsible-content", class CollapsibleContent extends HTMLElement {
    constructor() {
      super();
      // Define observed attributes
      this.isExpanded = this.hasAttribute('expanded');
      this.initialHeight = this.getAttribute('initial-height') || '100px';
      this.contentWrapper = null;
      this.toggleButton = null;
      this.init();
    }

    static get observedAttributes() {
      return ['expanded', 'initial-height'];
    }

    init() {
      // Wrap the content
      this.contentWrapper = document.createElement('div');
      this.contentWrapper.className = 'collapsible-content__wrapper';
      // Move all children into wrapper
      while (this.firstChild) {
        this.contentWrapper.appendChild(this.firstChild);
      }
      this.appendChild(this.contentWrapper);

      // Create toggle button
      this.toggleButton = document.createElement('button');
      this.toggleButton.className = 'collapsible-content__toggle';
      this.toggleButton.textContent = this.isExpanded ? 'Show Less' : 'Show More';
      this.appendChild(this.toggleButton);

      // Set initial state
      this.updateState();

      // Add click listener
      this.toggleButton.addEventListener('click', () => {
        this.isExpanded = !this.isExpanded;
        this.updateState();
      });
    }

    updateState() {
      if (this.isExpanded) {
        this.contentWrapper.style.maxHeight = this.contentWrapper.scrollHeight + 'px';
        this.toggleButton.textContent = '- Show Less';
      } else {
        this.contentWrapper.style.maxHeight = this.initialHeight;
        this.toggleButton.textContent = '+ Read More';
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'expanded') {
        this.isExpanded = this.hasAttribute('expanded');
        this.updateState();
      } else if (name === 'initial-height') {
        this.initialHeight = newValue || '100px';
        if (!this.isExpanded) {
          this.updateState();
        }
      }
    }

    connectedCallback() {
      // Add necessary styles
      const style = document.createElement('style');
      style.textContent = `
        collapsible-content {
          display: block;
        }
        .collapsible-content__wrapper {
          overflow: hidden;
          transition: max-height 0.3s ease-out;
        }
        .collapsible-content__toggle {
          display: block;
          margin: 10px 0;
          padding: 8px 16px;
          border: none;
          background: transparent;
          color: var(--swiper-theme-color, #007bff);
          cursor: pointer;
          font-size: 14px;
        }
        .collapsible-content__toggle:hover {
          color: var(--swiper-theme-color, #007bff);
          background: transparent;
        }
      `;
      this.appendChild(style);
    }
  })

  customElements.define('download-button', class extends HTMLElement {
    constructor() {
      super();
      this.downloading = false;
    }
    connectedCallback() {
      this.addEventListener('click', () => {
        const link = this.dataset.link;
        const filename = this.dataset.filename || 'download';
        this.downloadFile(link, filename);
      });
    }
    async downloadFile(url, filename) {
      if (!url || this.downloading) return;
      this.downloading = true;
      this.style.cursor = 'not-allowed';
      try {
        this.classList.add('button-loading');
        const response = await fetch(url);
        const blob = await response.blob();
        
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename || 'download';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        
        // 清理
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error('下载失败:', error);
        // 降级到直接打开链接
        window.location.href = url;
      } finally {
        this.classList.remove('button-loading');
        this.downloading = false;
        this.style.cursor = 'pointer';
      }
    }
  })

  // 视频弹窗组件 - 全局单例
  customElements.define('video-popup', class VideoPopup extends HTMLElement {
    constructor() {
      super();
      this.render();
      this.bindEvents();
    }

    render() {
      this.innerHTML = `
        <div class="video-popup-overlay">
          <div class="video-popup-content">
            <div class="video-popup-close">×</div>
            <div class="video-popup-player"></div>
          </div>
        </div>
      `;
    }

    bindEvents() {
      // 关闭按钮
      this.querySelector('.video-popup-close').onclick = () => this.close();
      // 点击遮罩关闭
      this.querySelector('.video-popup-overlay').onclick = (e) => {
        if (e.target.classList.contains('video-popup-overlay')) this.close();
      };
      // ESC 关闭
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });

      // 🔑 事件委托：监听所有带 data-video-popup 的点击
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-video-popup]');
        if (trigger) {
          e.preventDefault();
          this.open(trigger.dataset.videoUrl, trigger.dataset.videoType);
        }
      });
    }

    open(url, type = 'youtube') {
      const player = this.querySelector('.video-popup-player');
      player.innerHTML = this.getEmbed(url, type);
      this.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.removeAttribute('open');
      this.querySelector('.video-popup-player').innerHTML = '';
      document.body.style.overflow = '';
    }

    getEmbed(url, type) {
      const videoId = this.extractVideoId(url, type);
      if (type === 'youtube') {
        return `<iframe src="https://www.youtube.com/embed/${videoId}?enablejsapi=1&autoplay=1" 
                frameborder="0" allowfullscreen allow="autoplay"></iframe>`;
      }
      if (type === 'vimeo') {
        return `<iframe src="https://player.vimeo.com/video/${videoId}?autoplay=1" 
                frameborder="0" allowfullscreen allow="autoplay"></iframe>`;
      }
      // 直接视频文件
      return `<video src="${url}" controls autoplay></video>`;
    }

    extractVideoId(url, type) {
      if (type === 'youtube') {
        const match = url.match(/(?:v=|\/embed\/|\.be\/)([^&?#]+)/);
        return match?.[1] || '';
      }
      if (type === 'vimeo') {
        const match = url.match(/vimeo\.com\/(\d+)/);
        return match?.[1] || '';
      }
      return url;
    }
  });

})();
